(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-file-upload"] = factory();
	else
		root["vue-file-upload"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 251:
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxwYXRoIGQ9Ik0xMiAxNS43NVY4LjI1IiBzdHJva2U9IiNGRjQzNUEiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiAvPgoJPHBhdGggZD0iTTEyIDE4QzEyLjY5MDQgMTggMTMuMjUgMTguNTU5NiAxMy4yNSAxOS4yNUMxMy4yNSAxOS45NDA0IDEyLjY5MDQgMjAuNSAxMiAyMC41QzExLjMwOTYgMjAuNSAxMC43NSAxOS45NDA0IDEwLjc1IDE5LjI1QzEwLjc1IDE4LjU1OTYgMTEuMzA5NiAxOCAxMiAxOFoiIGZpbGw9IiNGRjQzNUEiIC8+Cgk8cGF0aCBkPSJNMTMuNTg1MSAxLjk4NzcxVjEuOTg3NzFDMTMuMTU1MSAxLjExMjM2IDEyLjA5NyAwLjc1MTMxIDExLjIyMTYgMS4xODEyOEMxMC44NzEgMS4zNTM1IDEwLjU4NzQgMS42MzcxMSAxMC40MTUyIDEuOTg3NzFMMS4xNTI4NyAyMC44NTY3VjIwLjg1NjdDMC43OTA1MzEgMjEuNTkzOCAxLjA5NDMzIDIyLjQ4NTEgMS44MzE0MyAyMi44NDc1QzIuMDM1ODggMjIuOTQ4IDIuMjYwNjggMjMuMDAwMiAyLjQ4ODUgMjNIMjEuNTExOFYyM0MyMi4zMzMyIDIzLjAwMDUgMjIuOTk5NSAyMi4zMzUxIDIzIDIxLjUxMzhDMjMuMDAwMiAyMS4yODYgMjIuOTQ4IDIxLjA2MTIgMjIuODQ3NSAyMC44NTY3TDEzLjU4NTEgMS45ODc3MVoiIHN0cm9rZT0iI0ZGNDM1QSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+Cjwvc3ZnPgo=";

/***/ }),

/***/ 655:
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxwYXRoIGQ9Ik0zNS45OTk2IDQ2QzQxLjUyMjUgNDYgNDUuOTk5NiA0MS41MjI4IDQ1Ljk5OTYgMzZDNDUuOTk5NiAzMC40NzcyIDQxLjUyMjUgMjYgMzUuOTk5NiAyNkMzMC40NzY4IDI2IDI1Ljk5OTYgMzAuNDc3MiAyNS45OTk2IDM2QzI1Ljk5OTYgNDEuNTIyOCAzMC40NzY4IDQ2IDM1Ljk5OTYgNDZaIiBzdHJva2U9IiM4RTkzOUYiIHN0cm9rZS13aWR0aD0iMiIgLz4KCTxwYXRoIGQ9Ik0yNS45OTk2IDQ2SDExLjk5OTZDOC42ODU5MyA0NiA1Ljk5OTYzIDQzLjMyMzQgNS45OTk2MyA0MC4wMDk3QzUuOTk5NjMgMzEuNTczMSA1Ljk5OTYzIDE2LjU5NjIgNS45OTk2MyAxMSIgc3Ryb2tlPSIjOEU5MzlGIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KCTxwYXRoIGQ9Ik00MS45OTk2IDIzVjExTDMyLjk5OTYgMkgxMi45OTk2QzExLjg5NTEgMiAxMC45OTk2IDIuODk1NDMgMTAuOTk5NiA0VjM5QzEwLjk5OTYgNDAuMTA0NiAxMS44OTUxIDQxIDEyLjk5OTYgNDFIMjIuNDk5NiIgc3Ryb2tlPSIjOEU5MzlGIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KCTxwYXRoIGQ9Ik0zNS45OTg3IDQwLjk5OThMMzUuOTk5NiAzMSIgc3Ryb2tlPSIjOEU5MzlGIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgLz4KCTxwYXRoIGQ9Ik0zMC45OTkyIDM2TDQwLjk5OSAzNiIgc3Ryb2tlPSIjOEU5MzlGIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgLz4KCTxwYXRoIGQ9Ik0zMi45OTk2IDExSDMxLjk5OTZDMzEuOTk5NiAxMS41NTIzIDMyLjQ0NzMgMTIgMzIuOTk5NiAxMlYxMVpNNDEuOTk5NiAxMkM0Mi41NTE5IDEyIDQyLjk5OTYgMTEuNTUyMyA0Mi45OTk2IDExQzQyLjk5OTYgMTAuNDQ3NyA0Mi41NTE5IDEwIDQxLjk5OTYgMTBWMTJaTTMxLjk5OTYgMlYxMUgzMy45OTk2VjJIMzEuOTk5NlpNMzIuOTk5NiAxMkg0MS45OTk2VjEwSDMyLjk5OTZWMTJaIiBmaWxsPSIjOEU5MzlGIiAvPgo8L3N2Zz4K";

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "";
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ entry_lib)
});

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ const setPublicPath = (null);

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../node_modules/pug-plain-loader/index.js!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueFileUpload.vue?vue&type=template&id=5a89953b&scoped=true&lang=pug&
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sf-file-upload",on:{"drag":function($event){$event.stopPropagation();$event.preventDefault();},"dragstart":function($event){$event.stopPropagation();$event.preventDefault();},"dragend":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragLeave.apply(null, arguments)},"dragover":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragOver.apply(null, arguments)},"dragenter":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragOver.apply(null, arguments)},"dragleave":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDragLeave.apply(null, arguments)},"drop":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onDrop.apply(null, arguments)}}},[(_vm.fileTypeError || _vm.fileSizeError)?_c('div',{staticClass:"error",attrs:{"id":`error-${_vm.uuid}`}},[_c('img',{attrs:{"src":__webpack_require__(251)}}),(_vm.fileTypeError)?_c('p',[_vm._v(_vm._s(_vm.fileTypeErrorText))]):_vm._e(),(_vm.fileSizeError)?_c('p',[_vm._v(_vm._s(_vm.fileSizeErrorText))]):_vm._e()]):_vm._e(),_c('input',_vm._b({ref:"fileInput",staticClass:"sr-only sf-file-upload__input",attrs:{"id":"random","type":"file","accept":_vm.accept,"multiple":_vm.multiple,"aria-describedby":_vm.fileTypeError || _vm.fileSizeError ? `error-${_vm.uuid}` : false,"aria-invalid":_vm.fileTypeError || _vm.fileSizeError ? 'true' : false},on:{"change":_vm.onUpload}},'input',_vm.$attrs,false)),_c('label',{staticClass:"sf-file-upload-box",class:{ 'sf-file-upload-box--darg-over' : _vm.dragOver},attrs:{"for":"random"}},[_c('img',{attrs:{"src":__webpack_require__(655)}}),(_vm.isMobile)?_c('span',[_vm._t("mobile-text",function(){return [_vm._v("Tallózzon "),_c('span',{staticClass:"sf-file-upload-box__link"},[_vm._v("dokumentumot mobilkészülékéről")])]})],2):_c('span',[_vm._t("tablet-text",function(){return [_vm._v("Dobja ide a dokumentumot vagy "),_c('span',{staticClass:"sf-file-upload-box__link"},[_vm._v("tallózzon a számítógépéről")]),_vm._v(".")]})],2)])])
}
var staticRenderFns = []


;// CONCATENATED MODULE: ./src/components/VueFileUpload.vue?vue&type=template&id=5a89953b&scoped=true&lang=pug&

;// CONCATENATED MODULE: ./src/common/check-file-types.js
const getExtensions = (acceptVal) => {
	return acceptVal
		.toLowerCase()
		.split(',')
		.filter((acceptParts) => !acceptParts.includes('/'))
		.map((s) => s.trim());
};
const getAccepts = (acceptVal) => {
	return acceptVal
		.toLowerCase()
		.split(',')
		.map((accept) => {
			return accept.split('/').map((part) => part.trim());
		})
		.filter((acceptParts) => acceptParts.length === 2);
};

const checkAccepts = (file, accepts) => {
	const [typeMain, typeSub] = file.type
		.toLowerCase()
		.split('/')
		.map((s) => s.trim());
	for (const [acceptMain, acceptSub] of accepts) {
		if (typeMain === acceptMain && (acceptSub === '*' || typeSub === acceptSub)) {
			return true;
		}
	}
};
const checkExtensions = (file, extensions) => {
	for (const extension of extensions) {
		if (file.name.toLowerCase().endsWith(extension)) {
			return true;
		}
	}
};
/* harmony default export */ const check_file_types = ((files, acceptVal) => {
	if (!acceptVal) {
		return;
	}
	const extensions = getExtensions(acceptVal);
	const accepts = getAccepts(acceptVal);
	const predicate = (item) => {
		const acceptedValid = checkAccepts(item, accepts);
		if (acceptedValid) {
			return true;
		} else {
			const extensionValid = checkExtensions(item, extensions);
			if (extensionValid) {
				return true;
			}
		}
		return false;
	};
	return files.filter(predicate);
});

;// CONCATENATED MODULE: ../../node_modules/@ui-common/sf-js-utils/dist/sf-js-utils.esm.js
var t=Object.freeze({__proto__:null,ADDRESS_CARD:"^\\d{6}[a-zA-Z]{2}$",ALL_PHONE:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$","^(70|20|30|31)\\s\\d{3}\\s\\d{4}$"],BANK_ACCOUNT_SIXTEEN_NUMBERS:"^\\d{8}-\\d{8}$",BANK_ACCOUNT_THIRTEEN_NUMBERS:"^\\d{5}-\\d{8}$",BANK_ACCOUNT_TWENTY_FOUR_NUMBERS:"^\\d{8}-\\d{8}-\\d{8}$",DATE_SEPARATORS:/[.,\/ -]/,DEVIZA_BANK_ACCOUNT_NUMBER_PATTERN:"^75\\d{3}-\\d{5}88\\d$",FOREIGN_PHONE_REGEX:/^\d{1,3}-\d{1,10}$/,FOREIGN_ZIP_CODE:/^[\da-zA-Z]{1,10}$/g,FULLNAME:"^(.+[ ].+)$|^$",HEX:/#[0-9a-fA-F]{6}/,IDENTITYS:{"personal-id":"^\\d{6}[a-zA-Z]{2}$","drivers-license":"^[a-zA-Z]{2}\\d{6}$",passport:"[a-zA-Z]{2}\\d{7}$"},IOS:/ipad|iphone/i,LANDLINE_PHONES:["^1\\s\\d{3}\\s\\d{4}$","^[02-9]\\d\\s\\d{3}\\s\\d{3,4}$"],LAST_FOUR_DIGITS:/^\d{4}$/,MOBILE_PHONE:"^(70|20|30|31)\\s\\d{3}\\s\\d{4}$",NAME:"^[\\p{L}\\s\\.\\-\\']*$",PENSIONER_NUMBER:"^\\d{3}-\\d{5}-\\d{1}$",TAX_NUMBER:"^\\d{8}-\\d{1}-\\d{2}$",YEAR:"^\\d{4}$",ZIP_CODE:"^\\d{4}$"});var e=Object.freeze({__proto__:null,HUNGARIAN_PHONE_NUMBER_PREFIX:"+36",OTP_BANK_ACCOUNT_NUMBER_PREFIX:"117"});var r=Object.freeze({__proto__:null,COOKIE_GDPR_LEVEL:"gdpr_level",GDPR_LEVELS:{LOW:1,MEDIUM:2,HIGH:3}});var d=Object.freeze({__proto__:null,BACKEND_DATE:"YYYY-MM-DD",DISPLAY_DATE:{hu:"YYYY.MM.DD.",en:"MM/DD/YYYY"},DISPLAY_TIME:{hu:"HH:mm",en:"hh:mm A"}});function i(){window.onkeydown=function(t){"Space"===t.code&&t.target==document.body&&t.preventDefault()}}function o(t){for(var e=0,r=0;t;){if("BODY"==t.tagName){var d=t.scrollLeft||document.documentElement.scrollLeft,i=t.scrollTop||document.documentElement.scrollTop;e+=t.offsetLeft-d+t.clientLeft,r+=t.offsetTop-i+t.clientTop}else e+=t.offsetLeft-t.scrollLeft+t.clientLeft,r+=t.offsetTop-t.scrollTop+t.clientTop;t=t.offsetParent}return{x:e,y:r}}function s(t){let e=[],r=t.parentNode.firstChild;for(;r;)1===r.nodeType&&r!==t&&e.push(r),r=r.nextSibling;return e}function n(t,e,r){return r=r?parseInt(r,10):0,"number"==typeof e?t.slice(r,r+e):t}function p(t){return void 0!==t&&null!=t?Math.floor(t/12)+" év":""}const u=767,_=959,h=1279;var a={data:()=>({viewportWidth:null}),methods:{setViewportWidth(){this.viewportWidth=window.innerWidth}},computed:{isMobile(){return this.viewportWidth<=u},isTablet(){return this.viewportWidth>u&&this.viewportWidth<_},isDesktop(){return this.viewportWidth>_&&this.viewportWidth<h},isLargeDesktop(){return this.viewportWidth>h}},created(){window.addEventListener("resize",this.setViewportWidth),this.setViewportWidth()},mounted(){this.setViewportWidth()},beforeDestroy(){window.removeEventListener("resize",this.setViewportWidth)}},E=(t=8)=>{let e="";const r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";for(let d=0;d<t;d++)e+=r.charAt(Math.floor(62*Math.random()));return e},l={data(){return{uuid:this.id||E()}},props:{id:{required:!1,type:String}}},N={mixins:[l],props:{errorId:{required:!1,type:String},addonId:{required:!1,type:String},prefixId:{required:!1,type:String},tooltipId:{required:!1,type:String},addon:{type:String,required:!1},prefix:{type:String,required:!1}},computed:{computedAddonId(){const t=this.addon?`${this.uuid}-addon`:null;return this.addonId||t},computedPrefixId(){const t=this.prefix?`${this.uuid}-prefix`:null;return this.prefixId||t},ariaDescribedBy(){const t=[];return this.$attrs["aria-describedby"]&&t.push(this.$attrs["aria-describedby"]),this.errorId&&t.push(this.errorId),this.computedAddonId&&t.push(this.computedAddonId),this.computedPrefixId&&t.push(this.computedPrefixId),this.tooltipId&&t.push(this.tooltipId),t.join(" ")}}},c={props:{hasError:{type:Boolean,required:!1,default:!1}}};

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueFileUpload.vue?vue&type=script&lang=js&




/* harmony default export */ const VueFileUploadvue_type_script_lang_js_ = ({
	data() {
		return {
			dragOver: false,
			files: [],
			fileTypeError: false,
			fileSizeError: false
		};
	},
	inheritAttrs: false,
	props: {
		/**
		 * @model
		 */
		value: {
			required: true
		},
		/**
		 * The types of file extensions, that the input will accept. If it's empty, itt will accept any file
		 */
		accept: {
			type: String,
			required: false
		},
		/**
		 * If it's set to 'multiple', the input can accept multiple files
		 */
		multiple: {
			type: String,
			required: false
		},
		/**
		 * File size upper limit
		 */
		fileSize: {
			type: String,
			required: false,
			validator(val) {
				return /\d+(kb|mb)/.test(val);
			},
			default: '10mb'
		},
		/**
		 * Text shown when the file size is invalid
		 */
		fileSizeErrorText: {
			type: String,
			required: false,
			default: 'Túl nagy a file mérete, kérjük, cseréld!'
		},
		/**
		 * Text shown when the file type is invalid
		 */
		fileTypeErrorText: {
			type: String,
			required: false,
			default: 'Nem megfelelő file formátum, kérjük, cseréld!'
		}
	},
	mixins: [N, a],
	watch: {
		value: {
			handler(val) {
				this.files = val || [];
			},
			immediate: true
		}
	},
	computed: {
		labelId() {
			return this.uuid + '-vss-lbl';
		},
		fileSizeInBytes() {
			const groups = /(\d+)(kb|mb)/.exec(this.fileSize);
			const size = groups[1];
			const prefix = groups[2];
			let multiplier;
			switch (prefix) {
				case 'kb':
					multiplier = 1024;
					break;
				case 'mb':
					multiplier = 1024 * 1024;
					break;
				default:
					console.error('kb or mb prefix is required');
			}
			if (multiplier) {
				return size * multiplier;
			} else {
				return 0;
			}
		}
	},
	methods: {
		resetErrors() {
			this.fileTypeError = false;
			this.fileSizeError = false;
		},
		checkFileType(files) {
			const validFiles = this.accept ? check_file_types(files, this.accept) : files;
			if (!validFiles.length) {
				this.fileTypeError = true;
			}
			return validFiles;
		},
		checkFileSizes(files) {
			const validFiles = files.filter((file) => {
				return file.size <= this.fileSizeInBytes;
			});
			if (files.length != validFiles.length) {
				this.fileSizeError = true;
			}
			return validFiles;
		},
		onDragOver() {
			this.dragOver = true;
		},
		onDragLeave() {
			this.dragOver = false;
		},
		onDrop(e) {
			this.resetErrors();
			const origFiles = Array.from(e.dataTransfer.files);
			const files = typeof this.multiple != 'undefined' ? origFiles : [origFiles[0]];
			this.files = this.checkFileType(files);
			this.files = this.checkFileSizes(this.files);
			this.onDragLeave();
			this.emitFiles();
		},
		onUpload() {
			if (this.$refs.fileInput.value) {
				this.resetErrors();
				this.files = this.checkFileType(Array.from(this.$refs.fileInput.files));
				this.files = this.checkFileSizes(this.files);
				this.$refs.fileInput.value = null;
				this.emitFiles();
			}
		},
		emitFiles() {
			this.$emit('input', this.files);
		}
	}
});

;// CONCATENATED MODULE: ./src/components/VueFileUpload.vue?vue&type=script&lang=js&
 /* harmony default export */ const components_VueFileUploadvue_type_script_lang_js_ = (VueFileUploadvue_type_script_lang_js_); 
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-58.use[0]!../../node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-58.use[1]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../../node_modules/@vue/cli-service/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-58.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-58.use[3]!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/VueFileUpload.vue?vue&type=style&index=0&id=5a89953b&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/VueFileUpload.vue?vue&type=style&index=0&id=5a89953b&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/VueFileUpload.vue



;


/* normalize component */

var component = normalizeComponent(
  components_VueFileUploadvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "5a89953b",
  null
  
)

/* harmony default export */ const VueFileUpload = (component.exports);
;// CONCATENATED MODULE: ../../node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ const entry_lib = (VueFileUpload);


})();

__webpack_exports__ = __webpack_exports__["default"];
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=vue-file-upload.umd.js.map